{
  "version": 1,
  "asset_id": "19656716-f76f-4b23-a68e-c8a5c489a671",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/19656716-f76f-4b23-a68e-c8a5c489a671/svc-saas-seo-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/19656716-f76f-4b23-a68e-c8a5c489a671/svc-saas-seo-640.webp",
  "original_filename": "svc-saas-seo-640.webp",
  "size": 6126,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:58Z"
}
